import * as React from "react";
import { renderLeagueName, renderStartTime } from "../RenderMethods";
export var renderCardDetails = function (props, componentPrefix) {
    return React.createElement("div", { className: "rj-ev-list__" + componentPrefix + "__section-item rj-ev-list__" + componentPrefix + "__details" },
        renderLeagueName(props.event.eventName, componentPrefix),
        renderStartTime(props.event.eventTime, props.dict, componentPrefix));
};
//# sourceMappingURL=renderCardDetails.js.map